module.exports = __webpack_public_path__ + "img/phone.ff8efd4c.svg";